(() => {
  if (!customElements.get('np-campaign-slider')) {
    customElements.define('np-campaign-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const slides = [...this.querySelectorAll('[data-np-campaign]')];
        const buttons = [...this.querySelectorAll('[data-np-campaign-index]')];
        let current = 0;
        const show = index => {
          current = index;
          slides.forEach((slide, i) => { slide.hidden = i !== index; });
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        };
        this.querySelector('[data-np-campaign-prev]')?.addEventListener('click', () => show((current + slides.length - 1) % slides.length));
        this.querySelector('[data-np-campaign-next]')?.addEventListener('click', () => show((current + 1) % slides.length));
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => show(index));
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
            if (next !== undefined) { event.preventDefault(); show(next); buttons[next].focus(); }
          });
        });
      }
    });
  }
  if (!customElements.get('np-product-shortcuts')) {
    customElements.define('np-product-shortcuts', class extends HTMLElement {
      connectedCallback() {
        const form = document.querySelector('.product__info-container');
        if (!form || this.observer) return;
        this.observer = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        });
        this.observer.observe(form);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
})();
